import { computed, defineComponent, watch, ref, onMounted, } from '@vue/composition-api';
import { getGoodsOfferList, } from '@/api/v2/requests/goods-offers';
import { genericTableRowSize } from '@/components/Table/__new__/_components/TableCellGeneric';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import { useGoodsOfferColumns } from '@/views/Brand/Applications/Offer/_composables/use-goods-offer-columns';
import { GenericAGTable } from '@/components/Table/AGTable/AGTable.vue';
import FloatingTextFilter from '@/components/Table/AGTable/_components/FloatingTextFilter.vue';
import FloatingSelectFilter from '@/components/Table/AGTable/_components/FloatingSelectFilter.vue';
import GoodsOfferStatusCell from '@/views/Brand/Applications/Offer/_components/GoodsOfferStatusCell/GoodsOfferStatusCell.vue';
import TableFooter from '@/views/_components/Table/TableFooter.vue';
import { useTableQueryParams } from '@/components/Table/_composables/use-table-query-params';
export default defineComponent({
    components: {
        TableFooter,
        TableLoader,
        // eslint-disable-next-line vue/no-unused-components
        FloatingTextFilter,
        // eslint-disable-next-line vue/no-unused-components
        FloatingSelectFilter,
        // eslint-disable-next-line vue/no-unused-components
        GoodsOfferStatusCell,
        AgTable: GenericAGTable(),
    },
    setup(props, ctx) {
        const params = ctx.root.$route.params;
        const isLoading = ref(false);
        const rows = ref([]);
        const totalCount = ref(0);
        const brandId = params.id;
        const agTableRef = ref(null);
        const { page, perPage, query: tableQuery, handleFilterChange: handleQueryFilterChange, handleSort, resetSort, } = useTableQueryParams(ctx, {
            defaultPerPage: 25,
            filterParams: {
                internalNumber: 'internalNumber',
                title: 'title',
                status: 'status',
                centralCostName: 'centralCostName',
            },
            fieldMap: {
                'centralCost.name': 'centralCostName',
            },
            staticParams: {
                brandId,
            },
        });
        const query = computed(() => {
            return { ...tableQuery.value };
        });
        const handleRowClick = (offer) => {
            ctx.root.$router.push({
                name: 'GoodsOfferDetails',
                params: {
                    id: brandId,
                    goodsOfferId: offer.id,
                },
            });
        };
        const fetchItems = async () => {
            isLoading.value = true;
            try {
                const { nodes, totalCount: nodesCount } = await getGoodsOfferList(query.value ?? {});
                totalCount.value = nodesCount;
                rows.value = nodes;
            }
            catch (err) {
                console.error('Error fetching goods offers:', err);
                ctx.root.$toast.error(ctx.root.$t(`brand-offers.errorFetchingGoods`));
            }
            finally {
                isLoading.value = false;
            }
        };
        const changePage = (newPage) => {
            page.value = newPage;
        };
        const handleFilterChange = (filterModel) => {
            handleQueryFilterChange(filterModel);
        };
        const handleSortChange = (field, sort) => {
            handleSort(field, sort);
        };
        const handleResetSort = () => {
            resetSort();
        };
        const handlePerPageChange = (newPerPage) => {
            perPage.value = newPerPage;
            page.value = 1;
        };
        onMounted(async () => {
            await fetchItems();
        });
        const { columns } = useGoodsOfferColumns(ctx);
        watch(query, () => {
            fetchItems();
        }, { deep: true });
        return {
            columns,
            tableQuery,
            page,
            perPage,
            totalCount,
            genericTableRowSize,
            rows,
            isLoading,
            handleRowClick,
            handleFilterChange,
            handleSortChange,
            handleResetSort,
            changePage,
            handlePerPageChange,
            agTableRef,
        };
    },
});
